export default function More() {
  const button = document.getElementById(`js_more_button`);
  if (button) moreClickEvent(button);
}

const openClassName = `is-open`;

const moreClickEvent = main => {
  main.addEventListener(`click`, _event => {
    const container = document.getElementById(`js_more_container`);
    container.classList.add(openClassName);
    main.style.display = `none`;
  });
};
